<template>
	<div class="drive-wrapper" ref="file">
		<div
			v-if="filteredFiles(null).length !== 0 || folders.length !== 0"
			@dragover="dragover"
			@dragleave="dragleave"
			@drop="drop($event)"
			class="file-container"
		>
			<div class="drop-container"></div>
			<table class="table">
				<colgroup>
					<col style="width: initial"/>
					<col style="width: initial"/>
					<col style="width: initial"/>
					<col style="width: initial"/>
					<col style="width: initial"/>
				</colgroup>
				<thead>
					<tr>
						<th class="table__cell table__cell--center table__type">Type</th>
						<th>Nom & description</th>
						<th>Partager<br /> à&nbsp;la&nbsp;classe</th>
						<th>Partager<br /> aux&nbsp;profs</th>
						<th> </th>
					</tr>
				</thead>
				<tbody>
					<folder
						v-for="folder in folders"
						:key="folder.id"
						:folder="folder"
						@remove="removeFolder"
						@getFiles="getFiles()"
						@getFolders="getFolders()"
						:selected="selected == folder.id ? true : false"
						@select="select"
						@redirect="
							this.$router.push({
								name: 'ClassFolder',
								params: { folderId: folder.id },
							})
						"
					/>
					<file-component
						v-for="file in filteredFiles(null)"
						:key="file.id"
						:file="file"
						:id="file.id"
						:selected="selectedFile == file.id ? true : false"
						@select="selectFile"
						@remove="removeFile"
					/>
				</tbody>
			</table>
		</div>
		<div
			v-if="filteredFiles(null).length == 0 && folders.length == 0"
			class="no-files"
			@dragover="dragover"
			@dragleave="dragleave"
			@drop="drop($event)"
		>
			<img class="bg" src="/img/class/bg-no-files.svg" alt="" />
			<img class="file" src="/img/class/dark-file.svg" alt="" />
			<p class="title">Déposez vos fichiers ici</p>
			<p class="subtitle">ou utiliser le bouton nouveau</p>
		</div>
	</div>
</template>

<script>

import { allFoldersForClassService, createFolderService } from '../../../../services/foldersService'
import { allFilesForClassService, createFileService } from '../../../../services/filesService'
import FileComponent from './FileComponent.vue'
import Folder from './FolderComponent.vue'
export default {
	components: {
		Folder,
		FileComponent
	},
	data() {
		return {
			folders: [],
			files: [],
			file: {},
			selectedFile: null,
			selected: null,
			loading: false
		}
	},
	methods: {
		removeFolder(e) {
			this.folders = this.folders.filter(x => x.id !== e)
			this.selectedFile = null
		},
		removeFile(e) {
			this.files = this.files.filter(x => x.id !== e)
		},
		select(e) {
			this.selected = e
			this.selectedFile = null
		},
		selectFile(e) {
			this.selectedFile = e
			this.selected = null
		},
		filteredFiles(e) {
			let files = this.files.filter(x => x.parent_folder_id == e)
			return files
		},

		async getFolders() {
			const res = await allFoldersForClassService(this.$route.params.id)
			this.folders = res.filter(x => x.parent_folder_id == null)
		},
		async getFiles() {
			this.files = await allFilesForClassService(this.$route.params.id)
		},
		dragover(event) {
			event.preventDefault()
			if (!event.currentTarget.classList.contains('drag-enter')) {
				event.currentTarget.classList.remove('not-drag-enter')
				event.currentTarget.classList.add('drag-enter')
			}
		},
		dragleave(event) {
			event.currentTarget.classList.add('not-drag-enter')
			event.currentTarget.classList.remove('drag-enter')
		},
		async drop(event) {
			event.currentTarget.classList.add('not-drag-enter')
			event.currentTarget.classList.remove('drag-enter')
			event.preventDefault()
			this.loading = true
			const dt = event.dataTransfer
			const items = dt.items
			if (items && items.length && items[0].webkitGetAsEntry) {
				// Gestion des dossiers via FileSystem API (Chrome/Edge)
				const tasks = []
				for (let i = 0; i < items.length; i++) {
					const entry = items[i].webkitGetAsEntry()
					if (entry) {
						tasks.push(this.processEntry(entry, null))
					}
				}
				await Promise.all(tasks)
			} else {
				// Fallback: fichiers simples
				this.$refs.file.files = dt.files
				for (let i = 0; i < this.$refs.file.files.length; i++) {
					await this.uploadOneFile(this.$refs.file.files[i], null)
				}
			}
			this.loading = false
			await Promise.all([this.getFiles(), this.getFolders()])
		},

		// Upload un fichier dans un dossier parent (peut être null)
		async uploadOneFile(file, parentFolderId) {
			const data = new FormData()
			data.append('name', file.name)
			if (parentFolderId) data.append('parent_folder_id', parentFolderId)
			data.append('class_id', this.$route.params.id)
			data.append('file_upload', file)
			data.append('teacher', this.$store.state.user.user || localStorage.userId)
			await createFileService(data)
		},

		// Crée un dossier serveur et retourne son id
		async ensureFolder(name, parentFolderId) {
			const payload = {
				name,
				class_id: this.$route.params.id,
				parent_folder_id: parentFolderId || null
			}
			const created = await createFolderService(payload)
			return created?.id
		},

		// Parcourt récursivement une entrée (fichier/dossier)
		async processEntry(entry, parentFolderId) {
			if (entry.isFile) {
				await new Promise((resolve, reject) => {
					entry.file(async file => {
						try {
							await this.uploadOneFile(file, parentFolderId)
							resolve()
						} catch (e) { reject(e) }
					})
				})
			} else if (entry.isDirectory) {
				const folderId = await this.ensureFolder(entry.name, parentFolderId)
				await new Promise((resolve, reject) => {
					const reader = entry.createReader()
					const readEntries = () => {
						reader.readEntries(async entries => {
							if (!entries.length) { resolve(); return }
							try {
								for (const ent of entries) {
									await this.processEntry(ent, folderId)
								}
								readEntries()
							} catch (e) { reject(e) }
						})
					}
					readEntries()
				})
			}
		}

	},

	created() {
		this.getFolders()
		this.getFiles()
	},

}
</script>

<style>
</style>
